import React, { useCallback, useEffect, useState } from "react";
import cookie from "react-cookies";
import getServices from "../../Services/get-service";
import download from "../../Assets/images/download.png";
import Checkbox from "@mui/material/Checkbox";
import more from "../../Assets/images/more.svg";
import DatePicker from "react-datepicker";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import "react-datepicker/dist/react-datepicker.css";
import {
  Menu,
  MenuItem,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from "@mui/material";
import DeActivateModal from "./DeActiviteModal";

function MainDetails() {
  const [searchTerm, setSearchTerm] = useState("");
  const [statusFilter, setStatusFilter] = useState("");
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [allUser, setAllUser] = useState([]);
  const [loading, setLoading] = useState(true);
  const [tokenReady, setTokenReady] = useState(() => Boolean(cookie.load("token")));
  const [click, setClick] = useState("all");
  const [currentPage, setCurrentPage] = useState(0); // Backend uses 0-based indexing
  const [pagination, setPagination] = useState(null);
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedUserId, setSelectedUserId] = useState(null);

  const [showProfileModal, setShowProfileModal] = useState(false);
  const [selectedUserProfile, setSelectedUserProfile] = useState(null);

  const [showDeactivateModal, setShowDeactivateModal] = useState(false);
  const [deactivateUserId, setDeactivateUserId] = useState(null);
  const [deactivateStatus, setDeactivateStatus] = useState("");

  const currentDate = new Date();
  const oneWeekAgo = new Date(currentDate.getTime() - 7 * 24 * 60 * 60 * 1000);
  const twoWeekAgo = new Date(currentDate.getTime() - 14 * 24 * 60 * 60 * 1000);

  const isDateValid = (date) => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    return date <= today;
  };

  useEffect(() => {
    if (tokenReady) return;

    const checkToken = () => {
      if (cookie.load("token")) {
        setTokenReady(true);
      }
    };

    checkToken();
    const tokenCheckInterval = setInterval(checkToken, 250);

    return () => {
      clearInterval(tokenCheckInterval);
    };
  }, [tokenReady]);

  const formatDate = (date) => {
    if (!date) return null;

    const localDate = new Date(date);
    const year = localDate.getFullYear();
    const month = String(localDate.getMonth() + 1).padStart(2, "0");
    const day = String(localDate.getDate()).padStart(2, "0");

    return `${year}-${month}-${day}`;
  };

  const displayValue = (value) => {
    if (value === null || value === undefined || value === "") return "N/A";
    return value;
  };

  const formatCurrency = (value) => {
    if (value === null || value === undefined || value === "") return "N/A";

    return new Intl.NumberFormat("en-NG", {
      style: "currency",
      currency: "NGN",
      minimumFractionDigits: 2,
    }).format(Number(value));
  };

  const formatStatus = (status) => {
    if (!status) return "N/A";
    return status.charAt(0).toUpperCase() + status.slice(1);
  };

  // const fetchUsers = () => {
  //   setLoading(true);
  //   const newTodate = toDate ? toDate.toISOString() : null;
  //   const newFromdate = fromDate ? fromDate.toISOString() : null;
    
  //   console.log('Fetching users with page:', currentPage); // Debug log
    
  //   // Pass pagination parameters to the backend
  //   getServices
  //     .getAllUserHalal(newFromdate, newTodate, currentPage, searchTerm, statusFilter)
  //     .then((response) => {
  //       const data = response.data.data;
  //       console.log('Received pagination:', data.pagination?.pagination); // Debug log
  //       setAllUser(data.users || []);
  //       setPagination(data.pagination?.pagination || null);
  //     })
  //     .catch((error) => {
  //       console.error("Error fetching users:", error);
  //       setAllUser([]);
  //       setPagination(null);
  //     })
  //     .finally(() => {
  //       setLoading(false);
  //     });
  // };


  const fetchUsers = useCallback(() => {
  setLoading(true);
  const newTodate = formatDate(toDate);
  const newFromdate = formatDate(fromDate);
  const status = statusFilter === "active" ? true : statusFilter === "inactive" ? false : "";
  
  getServices
    .getAllUserHalal(newFromdate, newTodate, currentPage, searchTerm.trim(), status) 
    .then((response) => {
      const data = response.data.data;
      
      setAllUser(data.users || []);
      setPagination(data.pagination?.pagination || data.pagination || null);
    })
    .catch((error) => {
      console.error("Error fetching users:", error);
      setAllUser([]);
      setPagination(null);
    })
    .finally(() => {
      setLoading(false);
    });
}, [fromDate, toDate, currentPage, searchTerm, statusFilter]);

  useEffect(() => {
    if (!tokenReady) return;

    fetchUsers();
  }, [tokenReady, fetchUsers]);

  const handlePreviousPage = () => {
    if (pagination?.hasPrevious) {
      setCurrentPage(prev => prev - 1);
    }
  };

  const handleNextPage = () => {
    if (pagination?.hasNext) {
      setCurrentPage(prev => prev + 1);
    }
  };

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
    setCurrentPage(0); 
  };

  const handleStatusFilterChange = (e) => {
    setStatusFilter(e.target.value);
    setCurrentPage(0); 
  };

  const downloadUserList = () => {
    if (!allUser || allUser.length === 0) {
      alert("No users to download");
      return;
    }
    const headers = [
      "First Name",
      "Last Name",
      "Email",
      "Phone Number",
      "Account Number",
      "Bank Name",
      "Date Added",
      "Status",
    ];
    const rows = allUser.map((user) => [
      user.firstName || "N/A",
      user.lastName || "N/A",
      user.emailAddress || "N/A",
      user.phoneNumber || "N/A",
      user.accountNumber || "N/A",
      user.bankName || "N/A",
      user.createdAt ? user.createdAt.split("T")[0] : "N/A",
      user.accountStatus === "active" ? "Active" : "Inactive",
    ]);
    const csvContent =
      "data:text/csv;charset=utf-8," +
      headers.join(",") +
      "\n" +
      rows.map((e) => e.join(",")).join("\n");
    const encodedUri = encodeURI(csvContent);
    const link = document.createElement("a");
    link.setAttribute("href", encodedUri);
    link.setAttribute("download", "user_list.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const openDeactivateModal = (userId, currentStatus) => {
    handleCloseMenu();
    setDeactivateUserId(userId);
    setDeactivateStatus(currentStatus === "active" ? "de" : "ac");
    setShowDeactivateModal(true);
  };

  const closeDeactivateModal = () => {
    setShowDeactivateModal(false);
    setDeactivateUserId(null);
    setDeactivateStatus("");
  };

  const handleOpenMenu = (event, userId) => {
    setAnchorEl(event.currentTarget);
    setSelectedUserId(userId);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
    setSelectedUserId(null);
  };

  const viewUserProfile = (userId) => {
    handleCloseMenu();

    const user = allUser?.find((u) => u.id === userId);

    if (user) {
      setSelectedUserProfile(user);
      setShowProfileModal(true);
    } else {
      alert("Failed to load user profile");
    }
  };

  const handleCloseProfileModal = () => {
    setShowProfileModal(false);
  };

  return (
    <div className="w-full px-2 sm:px-4">
      <DeActivateModal
        open={showDeactivateModal}
        handleClose={closeDeactivateModal}
        id={deactivateUserId}
        status={deactivateStatus}
      />

      <div className="flex flex-col sm:flex-row justify-between gap-2 sm:gap-0">
        <p className="text-text text-xl">All users</p>
        <div
          onClick={downloadUserList}
          className="flex flex-row gap-2 rounded-lg bg-primary-bg p-2 border-primary-border border cursor-pointer hover:bg-gray-100"
        >
          <p className="text-primary-color font-semibold text-sm sm:text-base">
            Download user list
          </p>
          <img src={download} height={24} width={24} alt="download" />
        </div>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-9 gap-4 my-8">
        <div className="sm:col-span-2 lg:col-span-3">
          <input
            placeholder="Search by name or email address"
            className="border border-gray-300 p-2 rounded w-full"
            value={searchTerm}
            onChange={handleSearchChange}
          />
        </div>

        <select
          value={statusFilter}
          onChange={handleStatusFilterChange}
          className="border border-gray-300 p-2 rounded w-full"
        >
          <option value="">Status</option>
          <option value="active">Active</option>
          <option value="inactive">Inactive</option>
        </select>

        <div className="pt-2 text-center sm:text-left">
          <button
            onClick={() => {
              setFromDate(oneWeekAgo);
              setToDate(new Date());
              setClick("7days");
              setCurrentPage(0);
            }}
            className={
              click === "7days"
                ? "font-normal text-sm inline-block text-back-color2 border-b-2 border-primary-color pb-2"
                : "font-normal text-sm inline-block text-back-color2 pb-2"
            }
          >
            Last 7 days
          </button>
        </div>

        <div className="pt-2 text-center sm:text-left">
          <button
            onClick={() => {
              setFromDate(twoWeekAgo);
              setToDate(new Date());
              setClick("14days");
              setCurrentPage(0);
            }}
            className={
              click === "14days"
                ? "font-normal text-sm inline-block text-back-color2 border-b-2 border-primary-color pb-2"
                : "font-normal text-sm inline-block text-back-color2 pb-2"
            }
          >
            Last 14 days
          </button>
        </div>

        <div className="pt-2 text-center sm:text-left">
          <button
            onClick={() => {
              setFromDate(null);
              setToDate(null);
              setClick("all");
              setCurrentPage(0);
            }}
            className={
              click === "all"
                ? "font-normal text-sm inline-block text-back-color2 border-b-2 border-primary-color pb-2"
                : "font-normal text-sm inline-block text-back-color2 pb-2"
            }
          >
            All Time
          </button>
        </div>

        <div className="flex flex-col sm:flex-row gap-2">
          <p className="pt-1 sm:pt-3">From:</p>
          <DatePicker
            className="w-full p-2 bg-white border border-gray-300 outline-0 rounded-lg"
            selected={fromDate}
            onChange={(date) => {
              setFromDate(date);
              setClick("custom");
              setCurrentPage(0);
            }}
            placeholderText="2026-05-07"
            maxDate={new Date()}
            filterDate={isDateValid}
            popperPlacement="top-end"
          />
        </div>

        <div className="flex flex-col sm:flex-row gap-2">
          <p className="pt-1 sm:pt-3">To:</p>
          <DatePicker
            className="w-full p-2 bg-white border border-gray-300 outline-0 rounded-lg"
            selected={toDate}
            onChange={(date) => {
              setToDate(date);
              setClick("custom");
              setCurrentPage(0);
            }}
            placeholderText="2026-05-14"
            maxDate={new Date()}
            filterDate={isDateValid}
            popperPlacement="top-end"
          />
        </div>
      </div>

      <div className="hidden md:flex flex-row justify-between items-center bg-primary-bg rounded-t-md rounded-r-md border-primary-border border p-4">
        <Checkbox />
        <p className="text-text flex-1 text-center">Name</p>
        <p className="text-text flex-1 text-center">Phone</p>
        <p className="text-text flex-1 text-center">Account Number</p>
        <p className="text-text flex-1 text-center">Date Added</p>
        <p className="text-text flex-1 text-center">Status</p>
        <p className="text-text flex-1 text-center">Action</p>
      </div>

      {loading ? (
        <div>
          {[...Array(10)].map((_, index) => (
            <div
              key={index}
              className="flex flex-col md:flex-row justify-between items-start md:items-center bg-white border-b border-gray-200 p-4 gap-2"
            >
              <div className="w-6 md:w-[5%]">
                <Skeleton width={24} height={24} />
              </div>

              <div className="flex-1 text-left md:text-center">
                <Skeleton width="80%" height={20} className="mb-2" />
                <Skeleton width="60%" height={16} />
              </div>

              <div className="flex-1 text-left md:text-center">
                <Skeleton width="60%" height={20} />
              </div>

              <div className="flex-1 text-left md:text-center">
                <Skeleton width="60%" height={20} />
              </div>

              <div className="flex-1 text-left md:text-center">
                <Skeleton width="60%" height={20} />
              </div>

              <div className="flex-1 text-left md:text-center">
                <Skeleton width="60%" height={20} />
              </div>

              <div className="flex-1 text-left md:text-center">
                <Skeleton width={24} height={24} className="mx-auto" />
              </div>
            </div>
          ))}
        </div>
      ) : (
        <>
          <div className="md:hidden">
            {allUser?.map((user, index) => (
              <div
                key={index}
                className="border rounded-lg p-4 mb-3 bg-white shadow-sm"
              >
                <p className="font-semibold">
                  {user.firstName || "N/A"} {user.lastName || "N/A"}
                </p>
                <p className="text-sm text-gray-500">
                  {user.emailAddress || "N/A"}
                </p>
                <p>
                  <b>Phone:</b> {user.phoneNumber || "N/A"}
                </p>
                <p>
                  <b>Account Number:</b> {user.accountNumber || "N/A"}
                </p>
                <p>
                  <b>Bank:</b> {user.bankName || "N/A"}
                </p>
                <p>
                  <b>Date Added:</b>{" "}
                  {user.createdAt ? user.createdAt.split("T")[0] : "N/A"}
                </p>
                <p>
                  <b>Status:</b>{" "}
                  <span
                    className={`inline-block px-2 py-1 rounded-full text-sm font-medium ${
                        user.accountStatus === 'active' ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'
                      }`}
                  >
                    {user.accountStatus === "active" ? "Active" : "Inactive"}
                  </span>
                  {/* <span
                    className={
                      user.accountStatus === "active"
                        ? "text-green-600 font-semibold"
                        : "text-red-600 font-semibold"
                    }
                  >
                    {user.accountStatus === "active" ? "Active" : "Inactive"}
                  </span> */}
                </p>
                <div className="flex justify-end mt-2">
                  <img
                    src={more}
                    alt="More options"
                    className="cursor-pointer"
                    onClick={(e) => handleOpenMenu(e, user.id)}
                  />
                </div>
              </div>
            ))}
          </div>

          <div className="hidden md:block">
            {allUser?.map((user, index) => (
              <div
                key={index}
                className="flex flex-row justify-between items-center bg-white border-b border-gray-200 p-4"
              >
                <Checkbox />
                <div className="flex-1 text-center break-words whitespace-normal min-w-0 px-1">
                  <p>{`${(user.firstName || "N/A").toUpperCase()} ${(
                    user.lastName || "N/A"
                  ).toUpperCase()}`}</p>
                  <h4 className="text-sm text-gray-500">
                    {user.emailAddress || "N/A"}
                  </h4>
                </div>
                <p className="flex-1 text-center break-words whitespace-normal min-w-0 px-1">
                  {user.phoneNumber || "N/A"}
                </p>
                <p className="flex-1 text-center break-words whitespace-normal min-w-0 px-1">
                  {user.accountNumber || "N/A"}
                </p>
                <p className="flex-1 text-center break-words whitespace-normal min-w-0 px-1">
                  {user.createdAt ? user.createdAt.split("T")[0] : "N/A"}
                </p>
                <p className="flex-1 text-center break-words whitespace-normal min-w-0 px-1">
                  <span
                    className={`inline-block px-2 py-1 rounded-full text-sm font-medium ${
                        user.accountStatus === 'active' ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'
                      }`}
                  >
                    {user.accountStatus === "active" ? "Active" : "Inactive"}
                  </span>
                </p>
                <div className="flex-1 text-center break-words whitespace-normal min-w-0 px-1">
                  <img
                    src={more}
                    alt="More options"
                    className="mx-auto cursor-pointer"
                    onClick={(e) => handleOpenMenu(e, user.id)}
                  />
                  <Menu
                    anchorEl={anchorEl}
                    open={Boolean(anchorEl && selectedUserId === user.id)}
                    onClose={handleCloseMenu}
                    sx={{
                      "& .MuiPaper-root": {
                        boxShadow: "none",
                      },
                    }}
                  >
                    <MenuItem onClick={() => viewUserProfile(user.id)}>
                      View user profile
                    </MenuItem>
                    <MenuItem
                      onClick={() =>
                        openDeactivateModal(user.id, user.accountStatus)
                      }
                      sx={{ color: "#ef4444" }}
                    >
                      {user.accountStatus === "active"
                        ? "Deactivate"
                        : "Activate"}{" "}
                      user account
                    </MenuItem>
                  </Menu>
                </div>
              </div>
            ))}
          </div>
        </>
      )}

      {pagination && pagination.totalPages > 1 && (
        <div className="flex flex-col sm:flex-row justify-between items-center gap-3 mt-4 mb-10">
          <button
            onClick={handlePreviousPage}
            disabled={!pagination.hasPrevious}
            className={`px-4 py-2 rounded-lg ${
              !pagination.hasPrevious
                ? "bg-gray-300 cursor-not-allowed"
                : "bg-primary-color text-white hover:bg-primary-color-dark"
            }`}
          >
            Previous
          </button>
          <p className="text-text text-sm sm:text-base">
            Page {(pagination.currentPage ?? 0) + 1} of {pagination.totalPages} 
            {/* ({pagination.totalItems} total users) */}
          </p>
          <button
            onClick={handleNextPage}
            disabled={!pagination.hasNext}
            className={`px-4 py-2 rounded-lg ${
              !pagination.hasNext
                ? "bg-gray-300 cursor-not-allowed"
                : "bg-primary-color text-white hover:bg-primary-color-dark"
            }`}
          >
            Next
          </button>
        </div>
      )}

      <Dialog
        open={showProfileModal}
        onClose={handleCloseProfileModal}
        keepMounted={false}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>User Profile</DialogTitle>
        <DialogContent>
          {selectedUserProfile && (
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 pt-2">
              <div>
                <p className="text-sm text-gray-500">First Name</p>
                <p className="font-medium">
                  {displayValue(selectedUserProfile.firstName)}
                </p>
              </div>

              <div>
                <p className="text-sm text-gray-500">Middle Name</p>
                <p className="font-medium">
                  {displayValue(selectedUserProfile.middleName)}
                </p>
              </div>

              <div>
                <p className="text-sm text-gray-500">Last Name</p>
                <p className="font-medium">
                  {displayValue(selectedUserProfile.lastName)}
                </p>
              </div>

              <div>
                <p className="text-sm text-gray-500">Email Address</p>
                <p className="font-medium">
                  {displayValue(selectedUserProfile.emailAddress)}
                </p>
              </div>

              <div>
                <p className="text-sm text-gray-500">Phone Number</p>
                <p className="font-medium">
                  {displayValue(selectedUserProfile.phoneNumber)}
                </p>
              </div>

              <div>
                <p className="text-sm text-gray-500">Account Number</p>
                <p className="font-medium">
                  {displayValue(selectedUserProfile.accountNumber)}
                </p>
              </div>

              <div>
                <p className="text-sm text-gray-500">Virtual Account Number</p>
                <p className="font-medium">
                  {displayValue(selectedUserProfile.virtualAccountNumber)}
                </p>
              </div>

              <div>
                <p className="text-sm text-gray-500">Virtual Account Balance</p>
                <p className="font-medium">
                  {formatCurrency(selectedUserProfile.virtualAccountBalance)}
                </p>
              </div>

              <div>
                <p className="text-sm text-gray-500">Bank Name</p>
                <p className="font-medium">
                  {displayValue(selectedUserProfile.bankName)}
                </p>
              </div>

              <div>
                <p className="text-sm text-gray-500">Account Status</p>
                <p
                  className={
                    selectedUserProfile.accountStatus === "active"
                      ? "font-medium text-green-600"
                      : "font-medium text-red-600"
                  }
                >
                  {formatStatus(selectedUserProfile.accountStatus)}
                </p>
              </div>

              <div>
                <p className="text-sm text-gray-500">KYC Status</p>
                <p className="font-medium">
                  {selectedUserProfile.kycStatus ? "Verified" : "Not Verified"}
                </p>
              </div>

              <div>
                <p className="text-sm text-gray-500">Date Joined</p>
                <p className="font-medium">
                  {selectedUserProfile.createdAt
                    ? new Date(
                        selectedUserProfile.createdAt
                      ).toLocaleDateString("en-US", {
                        year: "numeric",
                        month: "long",
                        day: "numeric",
                      })
                    : "N/A"}
                </p>
              </div>
            </div>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseProfileModal} color="primary">
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

export default MainDetails;
